import { localStorage } from '@muse-web/storages'

import { MTM_ENTITIES_KEY } from '../constants/storageKeys'

const MTM_ENTITIES = ['mtm_source', 'mtm_campaign', 'mtm_content', 'mtm_medium'] as const

type TMtmEntities = Partial<Record<(typeof MTM_ENTITIES)[number], string>>

export const clearMtmEntitiesFromStore = () => {
    localStorage.remove(MTM_ENTITIES_KEY)
}

const getMtmEntitiesFromStore = (): TMtmEntities =>
    (localStorage.get(MTM_ENTITIES_KEY) as TMtmEntities | null) ?? {}

const applyStoredEntities = (stored: TMtmEntities, searchParams: URLSearchParams) => {
    MTM_ENTITIES.forEach(entity => {
        const value = stored[entity]
        if (value) {
            searchParams.set(entity, value)
        }
    })
}

const updateStoredMtmEntities = (searchParams: URLSearchParams) => {
    clearMtmEntitiesFromStore()

    const newMtmEntities: TMtmEntities = {}
    MTM_ENTITIES.forEach(entity => {
        const value = searchParams.get(entity)
        if (value) {
            newMtmEntities[entity] = value
        }
    })

    localStorage.set(MTM_ENTITIES_KEY, newMtmEntities)
}

/**
 * Add MTM entities to the search string if they are not there, or store/update them
 * if they are. Returns the search string with MTM entities.
 */
export const withMtmEntities = (search: string): string => {
    const searchParams = new URLSearchParams(search)
    const storedMtmEntities = getMtmEntitiesFromStore()

    const hasMtmEntitiesInSearch = MTM_ENTITIES.some(entity => searchParams.has(entity))
    const hasStoredMtmEntities = Object.keys(storedMtmEntities).length > 0

    if (hasMtmEntitiesInSearch) {
        updateStoredMtmEntities(searchParams)
    } else if (hasStoredMtmEntities) {
        applyStoredEntities(storedMtmEntities, searchParams)
    }

    return searchParams.toString()
}
